import i18n from "@/utils/i18n";

const { t } = i18n.global;
export const translateTitle = (title: string) => t(`siteTitles.${title}`);
